// extracted by mini-css-extract-plugin
module.exports = {"withError":"withError_withError__3OjdO","text":"withError_text__2ST5I","error":"withError_error__EkPh5","info":"withError_info__2v7UQ"};